import { render, staticRenderFns } from "./orderfrezee.vue?vue&type=template&id=25dd50a3&scoped=true"
import script from "./orderfrezee.vue?vue&type=script&lang=js"
export * from "./orderfrezee.vue?vue&type=script&lang=js"
import style0 from "./orderfrezee.vue?vue&type=style&index=0&id=25dd50a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dd50a3",
  null
  
)

export default component.exports